import React from 'react'
import { listAffiliates, type CreateAffiliatePayload, createAffiliateByEmail, getAffiliateDetails, updateAffiliateById, isAffiliateCodeAvailable, suspendAffiliate, activateAffiliate, deleteAffiliate } from '../services/affiliateService'
import type { Affiliate } from '../types'

export function useAffiliates() {
  const [items, setItems] = React.useState<Affiliate[]>([])
  const [total, setTotal] = React.useState(0)
  const [page, setPage] = React.useState(1)
  const pageSize = 25
  const [search, setSearch] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const { items, total } = await listAffiliates({ search, page, pageSize })
      setItems(items)
      setTotal(total)
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao carregar afiliados')
    } finally {
      setLoading(false)
    }
  }, [search, page])

  React.useEffect(() => { load() }, [load])

  return { items, total, page, setPage, pageSize, search, setSearch, loading, error, load,
    createAffiliateByEmail, getAffiliateDetails, updateAffiliateById, isAffiliateCodeAvailable,
    suspendAffiliate, activateAffiliate, deleteAffiliate }
}
